module.exports = __webpack_public_path__ + "static/media/grupo-mola.43bf0387.png";